import { v4 as uuid } from 'uuid';
import { apiFetch } from 'modules/shared/fetch';
import {
  GetSettlementStatementParams,
  GetSettlementSummariesParams,
  RequestParams,
} from './accounts.types';

const correlationId = uuid();

export default class AccountsService {
  static async getAllAccounts({ appToken, appEnvironment }: RequestParams) {
    const response = await apiFetch(
      `/ledger-accounts/v1?application-id=${appToken}`,
      {
        // @ts-ignore
        appEnvironment,
        headers: {
          'lean-correlation-id': correlationId,
        },
      },
    );

    return response?.data;
  }

  static async getSettlementSchedule({
    appToken,
    appEnvironment,
  }: RequestParams) {
    const response = await apiFetch(
      `/settlements/v1/application-registrations/${appToken}`,
      {
        // @ts-ignore
        appEnvironment,
        headers: {
          'lean-correlation-id': correlationId,
        },
      },
    );

    return response?.data;
  }

  static async getSettlementSummaries({
    page,
    pageSize,
    appToken,
    appEnvironment,
  }: GetSettlementSummariesParams) {
    const response = await apiFetch(
      `/settlements/v1/summaries?application_id=${appToken}&page=${page}&size=${pageSize}`,
      {
        // @ts-ignore
        appEnvironment,
        headers: {
          'lean-correlation-id': correlationId,
        },
      },
    );

    return response?.data;
  }

  static async getSettlementStatement({
    settlementId,
    appEnvironment,
  }: GetSettlementStatementParams) {
    const response = await apiFetch(
      `/settlements/v1/${settlementId}/statements`,
      {
        // @ts-ignore
        appEnvironment,
        headers: {
          'lean-correlation-id': correlationId,
        },
      },
    );

    return response?.data;
  }
}
